import {initOrderSheetByStorage} from '@web/actions/orderSheetInfo'
import makeSlice from '@web/slices/orderTotal/sliceMaker'

import {Products, initOrderSheetByAPI, updateSafetyPurchaseAmountAction} from '../../actions'

const getAmount = (products: Products): number => {
    return products
        .map((product) => {
            const {items} = product

            const {orderAmount} = items.reduce(
                (acc, next) => {
                    if (next.orderAmount) {
                        acc.orderAmount += next.orderAmount
                    }
                    return {orderAmount: acc.orderAmount}
                },
                {orderAmount: 0},
            )
            return {
                // 상품 전체 금액
                orderAmount,
            }
        })
        .reduce((prev, {orderAmount}) => prev + orderAmount, 0)
}

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initOrderSheetByStorage.fulfilled, (state, {payload}) => {
                if (!payload.isCouponFailed) {
                    state.discountAmount = payload.data.orderTotal.discountAmount
                    // 배송비 정보를 복원하여, 복원한 배송지 정보의 초기화 로직에 활용
                    state.deliveryFeeAmount = payload.data.orderTotal.deliveryFeeAmount
                }
            })
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
                const {saleChannelInfo} = payload
                state.amount = getAmount(payload.products)

                state.deliveryFeeAmount = payload.delivery.totalPrepayOrderDeliveryFee
                state.purchaserCommissionsByPayMethodType = payload.purchaserCommissionsByPayMethodType ?? null
                if (payload.fleaMarketCommission) {
                    state.escrow = {
                        productAmount: payload.fleaMarketCommission.purchaserCommissionAmount,
                        deliveryFeeAmount: payload.fleaMarketCommission.deliveryFeeCommissionAmount,
                    }
                }
                if (saleChannelInfo.isLocalPay) {
                    state.cupDeposit = (function () {
                        const {totalDisposableCupDeposit, totalReusableCupDeposit} = payload.products.reduce(
                            (acc, next) => {
                                return {
                                    totalDisposableCupDeposit:
                                        acc.totalDisposableCupDeposit + (next.cupDeposit?.disposable ?? 0),
                                    totalReusableCupDeposit:
                                        acc.totalReusableCupDeposit + (next.cupDeposit?.reusable ?? 0),
                                }
                            },
                            {totalDisposableCupDeposit: 0, totalReusableCupDeposit: 0},
                        )

                        return {
                            disposable: totalDisposableCupDeposit,
                            reusable: totalReusableCupDeposit,
                        }
                    })()
                }
            })
            .addCase(updateSafetyPurchaseAmountAction, (state, {payload}) => {
                if (state.purchaserCommissionsByPayMethodType) {
                    state.safetyPurchaseAmount = state.purchaserCommissionsByPayMethodType[payload]?.amount ?? 0
                }
            })
    },
})

export default slice.reducer
